import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VBtn,{attrs:{"tile":"","large":"","outlined":"","color":"error"},on:{"click":_vm.cancelSubscriptionClicked}},[_vm._v(_vm._s(_vm.$t('account.sections.subscriptionBilling.cancelSubscription')))]),_c('ConfirmDialog',{ref:"cancelSubscriptionDialog",on:{"answered":_vm.cancelSubscriptionAnswered}}),_c('Alert',{ref:"iAlert"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }